//© 2025 Kaitlyn Troxell
import React, { useState } from "react";
import { signOut } from "firebase/auth";
import { auth } from "../firebase";
import ContractorDetailsModal from "./ContractorDetailsModal";

function ContractorsSidebar({ 
  contractors, 
  loading, 
  setShowAddContractor, 
  deleteContractor, 
  updateContractor 
}) {
  const [selectedContractor, setSelectedContractor] = useState(null);
  const [tradeFilter, setTradeFilter] = useState("All");
  const [searchQuery, setSearchQuery] = useState("");

  // Filter contractors by search query
  const filteredContractors = contractors.filter(contractor => {
    const matchesSearch = 
      (contractor.company || contractor.name || "").toLowerCase().includes(searchQuery.toLowerCase()) ||
      (contractor.trade || "").toLowerCase().includes(searchQuery.toLowerCase()) ||
      (contractor.phone || "").toLowerCase().includes(searchQuery.toLowerCase()) ||
      (contractor.email || "").toLowerCase().includes(searchQuery.toLowerCase());
    return matchesSearch;
  });

  // Group contractors by trade for better organization
  const groupedContractors = filteredContractors.reduce((acc, contractor) => {
    const trade = contractor.trade || "Other";
    if (!acc[trade]) {
      acc[trade] = [];
    }
    acc[trade].push(contractor);
    return acc;
  }, {});

  return (
    <>
      <div className="sidebar contractors-sidebar">
        <div className="sidebar-header">
          {/* Logout Button */}
          <button
            onClick={() => signOut(auth)}
            className="logout-btn"
            style={{ 
              width: '100%', 
              marginBottom: '10px',
              position: 'static'
            }}
          >
            Logout
          </button>
          <h4 className="sidebar-title">Contractors</h4>
          <button 
            onClick={() => setShowAddContractor(true)}
            className="add-contractor-btn"
          >
            + Add Contractor
          </button>

          {/* Search Box */}
          <div className="search-box" style={{ marginTop: '10px', marginBottom: '10px', position: 'relative' }}>
            <input
              type="text"
              placeholder="Search contractors..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="form-input"
              style={{ fontSize: '13px', padding: '6px 8px', width: '100%' }}
            />
            {searchQuery && (
              <button
                onClick={() => setSearchQuery("")}
                style={{
                  position: 'absolute',
                  right: '8px',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  background: 'none',
                  border: 'none',
                  cursor: 'pointer',
                  fontSize: '16px',
                  color: '#666',
                  padding: '0 4px'
                }}
              >
                ×
              </button>
            )}
          </div>

          {/* Trade Filter Dropdown */}
          <div className="phase-filter">
            <label htmlFor="tradeFilter" className="filter-label">
              Filter by Trade:
            </label>
            <select
              id="tradeFilter"
              value={tradeFilter}
              onChange={(e) => setTradeFilter(e.target.value)}
              className="filter-select"
            >
              <option value="All">All Trades</option>
              {Object.keys(groupedContractors).sort().map((trade, i) => (
                <option key={i} value={trade}>{trade}</option>
              ))}
            </select>
          </div>
        </div>

        <div className="sidebar-content">
          {loading && <div className="loading-text">Loading contractors...</div>}

          {!loading && contractors.length === 0 && (
            <div className="empty-state">
              No contractors found. Click "Add Contractor" to create your first one.
            </div>
          )}

          {!loading && filteredContractors.length === 0 && searchQuery && (
            <div className="empty-state">
              No contractors found matching "{searchQuery}"
            </div>
          )}

          {!loading && filteredContractors.length > 0 &&
            Object.keys(groupedContractors).sort().map((trade) => {
              // Apply filter
              if (tradeFilter !== "All" && tradeFilter !== trade) return null;

              return (
                <div key={trade} className="contractor-group">
                  <h5 className="trade-title">{trade}</h5>
                  {groupedContractors[trade].map((contractor) => (
                    <div
                      key={contractor.id}
                      className={`contractor-card ${
                        contractor.preferred
                          ? "preferred"
                          : contractor.active
                          ? "active"
                          : "inactive"
                      }`}
                      onClick={() => setSelectedContractor(contractor)}
                    >
                      <div className="contractor-name">
                        {contractor.company || contractor.name}
                        {contractor.preferred && " ⭐"}
                      </div>
                      <div className="contractor-phone">{contractor.phone}</div>
                      {contractor.email && (
                        <div className="contractor-email">{contractor.email}</div>
                      )}
                      {contractor.rating && (
                        <div className="contractor-rating">
                          {"⭐".repeat(Math.floor(contractor.rating))} ({contractor.rating}/5)
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              );
            })}
        </div>
      </div>

      {/* Modal for editing & deleting */}
      {selectedContractor && (
        <ContractorDetailsModal
          selectedContractor={selectedContractor}
          setSelectedContractor={setSelectedContractor}
          updateContractorById={updateContractor}
          deleteContractorById={deleteContractor}
        />
      )}
    </>
  );
}

export default ContractorsSidebar;